import React, { Component } from 'react';
import { Context } from 'context';

import isMobile from "ismobilejs";
import Sidebar from 'editor/sidebar/Sidebar';
import Workspace from 'editor/workspace/Workspace';
import HexViewer from 'editor/hexviewer/HexViewer';
import UtilityBar from "editor/utilitybar/UtilityBar";

import styles from 'editor/Editor.module.scss';

class Editor extends Component {
    static contextType = Context;

    state = {
        showNavigator: true,
        navigatorResize: false,
        navigatorHeight: 128,
        updateHexToFrom: false
    };

    componentDidMount() {
        window.addEventListener("mousemove", this.calculateNavigatorHeight);
        window.addEventListener("touchmove", this.calculateNavigatorHeight);
        window.addEventListener("mouseup", this.deactivateNavigatorResize);
        window.addEventListener("touchend", this.deactivateNavigatorResize);
    }

    componentWillUnmount() {
        // Exit full screen if it's active
        this.setState({ fullScreen: false })
    }

    // Shows or hides the hex viewer, and tells the context which, because the calibration is pulled only while the viewer can be seen (Task 13).
    toggleNavigator = () => {
        const showNavigator = !this.state.showNavigator;
        this.setState({showNavigator});
        this.context.setHexViewerVisible(showNavigator);
    };

    /**
     * Activate hexviewer resizing when the handle is clicked
     */
    activateNavigatorResize = () => {
        this.setState({
            navigatorResize: true
        })
    };

    /**
     * Deactivate the hexviewer resizing when the handle is clicked
     */
    deactivateNavigatorResize = () => {
        if(this.state.navigatorResize){
            this.setState({
                navigatorResize: false
            })
        }
    };

    updateHexToFrom = () => {
        this.setState({
            updateHexToFrom: !this.state.updateHexToFrom
        })
    }


    /**
     * Calculate and set the new height of the hexviewer on mousemove
     * @param event
     */
    calculateNavigatorHeight = (event) => {
        if(this.state.navigatorResize){

            let y = event.clientY;
            if(event.touches){
                y = event.touches[0].clientY;
            }

            let navigatorHeight = document.documentElement.clientHeight - y - 21;
            if(navigatorHeight <= 128) navigatorHeight = 128;
            this.setState({ navigatorHeight })
        }
    };

    render() {
        if (isMobile().any) return null; //todo: revisit this

        const modifiedMaps = this.context.folderStructure.reduce((accumulator, folder) => {
            return [ ...accumulator, ...folder.codeNames.map((map) => {
                return {
                    id: map.id,
                    swModified: map.swModified
                }
            })]
        }, []).filter((map) => { return map.swModified }).map((map) => { return map.id });

        const selectedMapId = this.context.getSelectedWindow()?.mapId;

        return (
            <div className={styles.editor}>
                <Sidebar/>
                <div className={styles.main}>
                    <Workspace navigatorResize={this.state.navigatorResize} updateHexToFrom={this.updateHexToFrom}/>
                    { this.state.showNavigator &&
                    <HexViewer
                        projectId={this.props.projectId}
                        toggleNavigator={this.toggleNavigator}
                        navigatorHeight={this.state.navigatorHeight}
                        activateNavigatorResize={this.activateNavigatorResize}
                        windows={this.context.windows}
                        selectedMapId={selectedMapId}
                        modifiedMaps={modifiedMaps}
                        modifiedCalibrationData={this.context.modifiedCalibrationData}
                        updateHexToFrom={this.state.updateHexToFrom}
                    />
                    }
                </div>
                <UtilityBar toggleNavigator={this.toggleNavigator} selectedMapId={selectedMapId}/>
            </div>
        );
    }
}

export default Editor;
